import { useMemo, useState } from "react";
// import { Steps } from "../../Types";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import { SmallContentBox } from "../../../../components/common";
import ProfessionalForm from "../ProfessionalForm";
import { useValueSet } from "../../../../hooks/useValueSet";
import { IFormInput } from "../../Types";
import {
  getCboValueSetId,
  getCboValueSetUrl,
} from "../../cboValueSetByConselho";

const defaultValues: IFormInput = {
  classe: undefined,
  uf: "",
  speciality: [],
  number: "",
};

export function Form() {
  const methods = useForm<IFormInput>({ defaultValues });
  const { handleSubmit, control, setValue } = methods;
  const [searchTerm, setSearchTerm] = useState("");

  // Conselho selecionado — define qual ValueSet de CBO (r5) carregar
  const selectedClasse = useWatch({ control, name: "classe" });
  const conselhoKey =
    typeof selectedClasse === "string" ? selectedClasse : undefined;
  const cboValueSetId = getCboValueSetId(conselhoKey);
  const cboCustomUrl = getCboValueSetUrl(conselhoKey);

  // CBO específico do conselho (r5). Sem mapeamento: não chama URL inválida.
  const { options: specialtiesOptions, loading: specialtiesLoading } =
    useValueSet({
      valueSet: cboValueSetId,
      version: "r5",
      searchTerm: searchTerm,
      // Só passa customUrl quando há ValueSet mapeado para o conselho
      customUrl: cboCustomUrl,
    });

  // Só exibe opções após digitar — evita lista completa bloquear o input no estado vazio
  const specialties = useMemo(() => {
    if (!searchTerm.trim() || !cboCustomUrl) return [];
    return (
      specialtiesOptions?.map((item) => ({
        value: item.code,
        label: `${item.display} - ${item.code}`,
        display: item.display,
      })) ?? []
    );
  }, [searchTerm, specialtiesOptions, cboCustomUrl]);

  return (
    <FormProvider {...methods}>
      <form style={{ height: "100%", width: "100%" }}>
        <SmallContentBox>
          <ProfessionalForm
            setSearchTerm={setSearchTerm}
            setValue={setValue}
            onNextButtonClick={handleSubmit}
            control={control}
            specialties={specialties}
            loading={specialtiesLoading}
          />
        </SmallContentBox>
      </form>
    </FormProvider>
  );
}
